import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "element-ui/lib/theme-chalk/index.css";
import {
  Pagination,
  Loading,
  Select,
  Option,
  Input,
  DatePicker,
} from "element-ui";
import "normalize.css";
import dayjs from "dayjs";

import "./plugins/ant-design-vue.js"; // 按需加载antd模块
import "../src/assets/scss/base.scss"; /*引入公共样式*/
import formatTime from "./plugins/filter";
import loading from "../src/components/common/loading/loading";
import link from "./components/common/DidLink";
import STitle from "./components/common/s-title/STitle";
import speaker from "./components/common/speaker/Speaker";

import { CONFIG } from "./conf";
import { COOKIE } from "./plugins/cookie";
import { API } from "./services/api";

import { Cascader, Popup, Calendar, Cell, CellGroup, Field } from "vant";
Vue.use(Cascader);
Vue.use(Popup);
Vue.use(Calendar);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Field);

Vue.use(CONFIG);
Vue.use(COOKIE);
Vue.use(API);
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;

Vue.component(Pagination.name, Pagination);
Vue.component(Select.name, Select);
Vue.component(Option.name, Option);
Vue.component(DatePicker.name, DatePicker);

//全局注册组件 loading
Vue.component("Loading", loading);
Vue.component("DidLink", link);
Vue.component("STitle", STitle); // <s-title :title="'防疫须知'">></s-title>
Vue.component("speaker", speaker);

Vue.prototype.formatTime = formatTime; //时间格式化
Vue.config.productionTip = false;
Vue.config.devtools = true; //todo 上线关闭
//创建 事件总线
Vue.prototype.$bus = new Vue();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
